import Card from '~/components/Card'
import ColorPicker from '~/components/ColorPicker'
import Icon from '~/components/Icon'
import Input from '~/components/Input'
import { DEFAULT_SETTINGS } from '~/utils/settings'
import type { TabMarcaProps } from './types'

/** Pestaña Marca: identidad visual de la empresa y de sus documentos. */
function TabMarca(props: TabMarcaProps) {
  const { form } = props

  return (
    <Card>
      <Card.Title>
        <div class="flex items-center">
          <Icon icon="material-symbols-light:palette-outline" size={20} class="mr-2" />
          <h2 class="text-xl font-semibold">Apariencia de la marca</h2>
        </div>
      </Card.Title>
      <Card.Body>
        <p class="text-sm text-foreground-subtle mb-4">Identidad visual de la empresa y de sus documentos.</p>
        <div class="space-y-4">
          <Input name="brandingAppName" label="Nombre de la marca" placeholder={(form.values().name as string) || 'Nombre de la empresa'} />
          <div>
            <span class="mb-1 block text-xs font-medium text-foreground-subtle">Color principal</span>
            <ColorPicker
              value={(form.values().brandingPrimaryColor as string) ?? DEFAULT_SETTINGS.quoteBranding.primaryColor}
              onChange={v => form.setValue('brandingPrimaryColor', v)}
              showAlpha={false}
            />
          </div>
          <Input name="brandingSecondaryColor" label="Color de filas alternas" />
        </div>
      </Card.Body>
    </Card>
  )
}

export default TabMarca
